export enum PhotoReportOrientationType {
    Portrait = 1,
    Landscape = 2,
  }